module.exports = __webpack_public_path__ + "img/fabu.edaf2f9e.png";